<template>
    <div class="employers-debts">
        <div class="grid-title">
            Должен забрать деньги у клиента:
        </div>
        <div class="employers-debts-grid" v-loading="loading">
            <template v-for="(column, index) in debtColumns">
                <div :key="'header_' + index" class="header-cell">
                    {{ column.headerName }}
                </div>
            </template>
            <template v-for="(debt, debtIndex) in debts">
                <template v-for="(column, columnIndex) in debtColumns">
                    <div
                        v-if="debt.debt > 0"
                        :key="debtIndex+ '_'+ columnIndex"
                        :class="column.fieldClass"
                        :title="debt[column.field]"
                    >
                        <template v-if="column.field === 'deal_id'">
                            <a :href="getDealLink(debt[column.field])" target="_blank" class="link">
                                {{ debt[column.field] }}
                            </a>
                        </template>
                        <template v-else-if="column.field === 'debt'">
                            <span :class="{'red': debt.debt < 0}">
                                {{ formatFinance(debt[column.field]) }}
                            </span>
                        </template>
                        <template v-else>
                            {{ debt[column.field] }}
                        </template>
                    </div>
                </template>
            </template>
        </div>
        <div class="total" v-if="debts.length">
            <span class="total-info">
                Итого {{ name }} должен забрать деньги у клиента: {{ formatFinance(debtsTotalAmount) }} руб.
            </span>
        </div>
    </div>
</template>

<script>
import { formatFinance } from '@/common/utilities';
import '@/assets/styles/debts.scss';

export default {
    name: 'EmployerDealsDebts',
    props: {
        id: {
            type: [String, Number],
            default: 0
        },
        name: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            debtColumns: [
                { headerName: 'Id сделки', field: 'deal_id', fieldClass: 'grid-cell' },
                { headerName: 'Дата замера', field: 'measurement_date', fieldClass: 'grid-cell' },
                { headerName: 'Дата монтажа', field: 'installation_date', fieldClass: 'grid-cell' },
                { headerName: 'Договор', field: 'contract', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Клиент', field: 'contact_name', fieldClass: 'grid-cell cut-text' },
                { headerName: 'Телефон клиента', field: 'contact_phone', fieldClass: 'grid-cell' },
                { headerName: 'Адрес', field: 'address', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Долг', field: 'debt', fieldClass: 'grid-cell text-right pr10' }
            ],
            loading: false,
            debts: []
        };
    },
    computed: {
        debtsTotalAmount() {
            return this.debts.reduce((sum, debt) => sum + (debt.debt > 0 ? +debt.debt : 0), 0);
        }
    },
    methods: {
        formatFinance,
        getDealLink(dealId) {
            return this.$router.resolve({ name: 'deal-card', params: { id: '' + dealId } }).href;
        },
        async getDebts() {
            this.loading = true;
            try {
                this.debts = await this.$store.dispatch('debts/getInstallerDealDebts', { entityId: this.id });
            } catch (error) {
                console.log(error.message);
            } finally {
                this.loading = false;
            }
        }
    },
    mounted() {
        this.getDebts();
    }
};
</script>
